export const REGION_END = '#endregion';

export const INPUT_MAPPINGS_REGION_START = '#region - Input mappings';
export const DATA_STREAMING_REGION_START = '#region - Data streaming';
export const AUTONOMOUS_ROUTINES_REGION_START = '#region - Autonomous routines';

export function isRegionStartLine(line: string, startMarker: string): boolean {
  return line.trim() === startMarker;
}

export function isRegionEndLine(line: string): boolean {
  return line.trim() === REGION_END;
}

export function isInputMappingsRegionStartLine(line: string): boolean {
  return isRegionStartLine(line, INPUT_MAPPINGS_REGION_START);
}

export function isDataStreamingRegionStartLine(line: string): boolean {
  return isRegionStartLine(line, DATA_STREAMING_REGION_START);
}

export function isAutonomousRoutinesRegionStartLine(line: string): boolean {
  return isRegionStartLine(line, AUTONOMOUS_ROUTINES_REGION_START);
}

export function isManagedBpsRegionStartLine(line: string): boolean {
  return isInputMappingsRegionStartLine(line) || isDataStreamingRegionStartLine(line) || isAutonomousRoutinesRegionStartLine(line);
}

/** True for any VS Code-style `#region` line, including user/custom regions. */
export function isGenericRegionStartLine(line: string): boolean {
  return /^#region\b/.test(line.trim());
}

/** 0-based end line after `startLine`, or null when unclosed or another region start appears first. */
export function findRegionEndLineIndexAfterStart(lines: readonly string[], startLine: number): number | null {
  for (let i = startLine + 1; i < lines.length; i++) {
    const line = lines[i] ?? '';
    if (isGenericRegionStartLine(line)) return null;
    if (isRegionEndLine(line)) return i;
  }
  return null;
}

/** Returns 0-based line indices for the first valid region block, or null when none qualify. */
export function findRegionSpanLineIndices(
  lines: readonly string[],
  isStartLine: (line: string) => boolean
): { startLine: number; endLine: number } | null {
  for (let startLine = 0; startLine < lines.length; startLine++) {
    if (!isStartLine(lines[startLine] ?? '')) continue;
    const endLine = findRegionEndLineIndexAfterStart(lines, startLine);
    if (endLine !== null) return { startLine, endLine };
  }
  return null;
}

export function isRegionInteriorEmpty(lines: readonly string[], span: { startLine: number; endLine: number }): boolean {
  for (let i = span.startLine + 1; i < span.endLine; i++) {
    if ((lines[i] ?? '').trim().length > 0) return false;
  }
  return true;
}
